import {z as zod} from "zod";

export enum PricingPlanNudgeStatus {
    expired = "82b6d925-f5c6-4116-ab34-3f6e3344c6f0",
    expiringIn7Days = "68e6e88a-fe59-45d0-b60b-0617e17c897f",
    healthy = "987f5d09-c619-47e1-856e-c86f8ada13f5",
    inGracePeriod = "7b398df5-4e98-4415-8c80-f86bcfb3a244",
};

export const pricingPlanNudgeStatusZodValidator = zod.enum(PricingPlanNudgeStatus);
